import { render, staticRenderFns } from "./OurStaffNewPage.vue?vue&type=template&id=2851a7e2&"
import script from "./OurStaffNewPage.vue?vue&type=script&lang=ts&"
export * from "./OurStaffNewPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports